import { Link } from 'react-router-dom';
import { categories, mangaList } from '@/mocks/manga';
import MangaCard from '@/components/base/MangaCard';

export default function CategorySection() {
  const categoryData = categories.map((cat) => {
    let catMangaList: typeof mangaList;
    switch (cat.slug) {
      case 'hanman':
        catMangaList = mangaList.filter((m) => m.category === '韩漫').slice(0, 4);
        break;
      case 'riman':
        catMangaList = mangaList.filter((m) => m.category === '日漫').slice(0, 4);
        break;
      case 'guoman':
        catMangaList = mangaList.filter((m) => m.category === '国漫').slice(0, 4);
        break;
      case 'remen':
        catMangaList = [...mangaList].sort((a, b) => b.views - a.views).slice(0, 4);
        break;
      default:
        catMangaList = mangaList.slice(0, 4);
    }
    return { ...cat, mangas: catMangaList };
  });

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按地域精选，找到你喜欢的漫画</p>
        </div>

        <div className="space-y-10">
          {categoryData.map((cat) => (
            <div key={cat.slug}>
              <div className="flex items-center justify-between mb-4 md:mb-5">
                <div className="flex items-center gap-2">
                  <span className="w-7 h-7 flex items-center justify-center bg-primary-100 text-primary-500 rounded-lg">
                    <i className={`${cat.icon} text-sm`}></i>
                  </span>
                  <h3 className="text-base md:text-lg font-heading text-foreground-950">{cat.name}</h3>
                  <span className="text-xs text-foreground-400">· {cat.description}</span>
                </div>
                <Link
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  查看全部
                  <i className="ri-arrow-right-line text-xs"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4 md:gap-5">
                {cat.mangas.map((manga) => (
                  <MangaCard key={manga.id} manga={manga} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}